// Swedish

const lang = {
  gateMediaPreviewHeader: 'Du kanske också gillar',
  loadmore: 'Visa mer',
  nextMedia: 'Nästa media',
  previousMedia: 'Tidigare media',
  closePost: 'Stäng inlägg',
  nextPost: 'Nästa inlägg',
  previousPost: 'Tidigare inlägg',
  outOfStock: 'Slut i lager',
  numberOfReviews(n) {
    return n === 1 ? 'omdöme' : 'omdömen'
  },
  reportFormField: 'Skriv ett meddelande',
  reportPost: 'Anmäl post',
  reportFormTitle: 'Vill du anmäla den här bilden?',
  reportFormDetails:
    'Om du anser att bilden är olämplig, misstänker att den bryter mot lagen eller inkräktar på någons rättigheter kan du rapportera innehållet. Om du rapporterar bilden/texten kommer innehållsmoderatorerna att meddelas och lämpliga åtgärder vidtas.',
  reportFormMessagePlaceholder: 'Skäl för anmälan',
  reportFormMessageLabel: 'Meddelande',
  reportFormEmailLabel: 'Din email',
  reportFormSubmitButtonText: 'Anmäl',
  reportFormCancelButtonText: 'Avbryt',
  reportFormSentTitle: 'Tack för din anmälan!',
  reportFormSentCloseButtonText: 'Stäng',
  cardAndTileAriaLabel: 'Lista över inlägg från konton på olika sociala medieplattformar',
  carouselAriaLabel: 'Karusell med inlägg från konton på olika sociala medieplattformar',
  singleAriaLabel: 'Nedan är ett inlägg från ett socialt medie-konto',
  poweredBy: 'Drivs av Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` publicerad ${date}` : ''
    const createdByString = userName ? ` skapad av ${userName}` : ''
    return `Foto${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Ladda upp din media',
  openTheGate: 'Öppna dialogrutan',
  gridRoleDescription: 'rutnät',
  carouselRoleDescription: 'karusell',
  tiktokVideoAriaLabel: 'Inbäddad TikTok-video. Tryck på spela för att se innehållet.',
  feedThumbnailAriaLabel: (postIndex, maxPosts) =>
    `Miniatyrbild av media ${postIndex + 1} av ${maxPosts}, öppnar dialog med socialt medieinnehåll och lista över utvalda produkter.`,
  carouselControlButtonsAriaLabel: 'Karusellkontrollknappar',
  gateCarouselIndicatorAriaLabel: (mediaIndex, maxMedia) =>
    `Media ${mediaIndex + 1} av ${maxMedia}`,
  showMoreCaption: 'Visa mer bildtext',
  showLessCaption: 'Visa mindre bildtext',
  originalPrice: (price) => `Originalpris: ${price}`,
  salesPrice: (price) => `Reapris: ${price}`,
  postPublishedBy: 'Inlägg publicerat av',
  mediaAltText: (isVideo, username, date, altText) => {
    const mediaType = isVideo ? 'Video' : 'Bild'
    const user = username ? `${username}` : 'okänd användare'
    const publishDate = date ? `den ${date}` : ''
    return `${mediaType} publicerad av ${user} ${publishDate}. Det kan vara ${altText}`
  },
  gateSlideAriaLabel: (postIndex, maxPosts) => `Inlägg ${postIndex + 1} av ${maxPosts}.`,
}

export default lang
